import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SlArrowRight, SlArrowLeft } from "react-icons/sl";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { base_URL } from "../../../../config/config";

const filterKeys = [
	{
		labelKey: "Exhibitions",
		valueKey: {
			"Conference/Seminars": ["Exhibitions"],
		},
	},
	{
		labelKey: "Team Building",
		valueKey: {
			"Corporate Events": ["Team Building"],
		},
	},
	{
		labelKey: "Staff Party",
		valueKey: {
			"Corporate Events": ["Staff Party"],
		},
	},
	{
		labelKey: "PR events",
		valueKey: {
			"Corporate Events": ["PR events"],
		},
	},
	{
		labelKey: "Corporate Retreat",
		valueKey: {
			"Corporate Events": ["Corporate Retreat"],
		},
	},
	{
		labelKey: "Corporate Gala dinner",
		valueKey: {
			"Corporate Events": ["Corporate Gala dinner"],
		},
	},
	{
		labelKey: "Wedding Reception",
		valueKey: {
			Weddings: ["Wedding Reception"],
		},
	},
	{
		labelKey: "Outdoor Wedding",
		valueKey: {
			Weddings: ["Outdoor Wedding"],
		},
	},
	{
		labelKey: "Wedding",
		valueKey: {
			Weddings: ["Wedding"],
		},
	},
	{
		labelKey: "Engagement",
		valueKey: {
			Dining: ["Engagement"],
		},
	},
	{
		labelKey: "Board Meetings",
		valueKey: {
			"Conference/Seminars": ["Board Meetings"],
		},
	},
	{
		labelKey: "Conference",
		valueKey: {
			"Conference/Seminars": ["Conference"],
		},
	},
	{
		labelKey: "Training Program",
		valueKey: {
			"Corporate Events": ["Training Program"],
		},
	},
	{
		labelKey: "Networking",
		valueKey: {
			"Conference/Seminars": ["Networking"],
		},
	},
	{
		labelKey: "16th Birthday Party",
		valueKey: {
			"Milestone Birthdays": ["16th Birthday Party"],
		},
	},
	{
		labelKey: "21st Birthday Party",
		valueKey: {
			"Milestone Birthdays": ["21st Birthday Party"],
		},
	},
	{
		labelKey: "50th Birthday Party",
		valueKey: {
			"Milestone Birthdays": ["50th Birthday Party"],
		},
	},
	{
		labelKey: "Kids Party",
		valueKey: {
			"Teen/Children": ["Kids Party"],
		},
	},
	{
		labelKey: "Teen Party",
		valueKey: {
			"Teen/Children": ["Teen Party"],
		},
	},
	{
		labelKey: "Proposals",
		valueKey: {
			"Special Big Events": ["Proposals"],
		},
	},
];

const baseEventsData1 = [
	/**@CorporateEvents */
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FTeam%20BUilding.jpg?alt=media&token=c2a84561-a887-4e51-8777-f26e044dd628",
		title: "Team Building",
		key: "Team Building",
		venues: 0,
		category: "Corporate Events",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FStaff%20Party.jpg?alt=media&token=88c3def7-9730-45b4-8790-de1c9869b80c",
		title: "Staff Party",
		key: "Staff Party",
		venues: 0,
		category: "Corporate Events",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FPR%20events.jpg?alt=media&token=71ad85d8-cba4-4424-8900-589c916e6094",
		title: "PR events",
		key: "PR events",
		venues: 0,
		category: "Corporate Events",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FExhibition.jpg?alt=media&token=3d7d4a81-e4e5-40c7-a527-6372dd3103e6",
		title: "Exhibitions",
		key: "Exhibitions",
		venues: 0,
		category: "Corporate Events",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FCorporate%20Retreat.jpg?alt=media&token=11ea6bcc-c91a-492f-8efd-172186cdeabb",
		title: "Corporate Retreat",
		key: "Corporate Retreat",
		venues: 0,
		category: "Corporate Events",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FGala%20Dinner.jpg?alt=media&token=d9a0f5b2-c92d-4f6d-a58c-41f792180c5b",
		title: "Gala dinner",
		key: "Corporate Gala dinner",
		venues: 0,
		category: "Corporate Events",
	},

	/**@Weddings */
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FWedding%20Reception.jpg?alt=media&token=4281dd40-4efd-4c21-945d-fe956771d537",
		title: "Wedding Reception",
		key: "Wedding Reception",
		venues: 0,
		category: "Weddings",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FOutdoor%20Wedding.jpg?alt=media&token=69570aaf-5064-498f-a290-ec31080bdab0",
		title: "Outdoor Wedding",
		key: "Outdoor Wedding",
		venues: 0,
		category: "Weddings",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FBeach%20Wedding.jpg?alt=media&token=d26ed24e-9cba-47d5-aa9a-35e1ab09b682",
		title: "Beach Wedding",
		key: "Wedding",
		venues: 0,
		category: "Weddings",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FEngagement%20Reception.jpg?alt=media&token=388056d5-bb33-4d76-9fe5-6a6f73f3599a",
		title: "Engagement",
		key: "Engagement",
		venues: 0,
		category: "Weddings",
	},

	/**@Meetings */
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FBoard%20Meeting.jpg?alt=media&token=fe95cabd-50e7-438d-bc3a-dcd90ef29245",
		title: "Board Meetings",
		key: "Board Meetings",
		venues: 0,
		category: "Meetings",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FConference.jpg?alt=media&token=23c7387f-f8df-4b0b-bf03-de0640759808",
		title: "Conferences",
		key: "Conference",
		venues: 0,
		category: "Meetings",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FTrainings.jpg?alt=media&token=0b0fee83-eac0-45a5-a3ff-3d201b31962a",
		title: "Trainings",
		key: "Training Program",
		venues: 0,
		category: "Meetings",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FNetworking.jpg?alt=media&token=d2b0589d-236c-4a4a-bf35-bc8955bdcfbb",
		title: "Networking",
		key: "Networking",
		venues: 0,
		category: "Meetings",
	},

	/**@BirthdayParties */
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FKids%20Birthday%20Party.jpg?alt=media&token=aa40e8d2-151a-44af-be40-af60cca44869",
		title: "Kids Party",
		key: "Kids Party",
		venues: 0,
		category: "Birthday Parties",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FTeen%20Birthday.jpg?alt=media&token=96914b92-b8ad-444b-94fe-e728ac34e1ca",
		title: "Teen Party",
		key: "Teen Party",
		venues: 0,
		category: "Birthday Parties",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2F16th%20Birthday.jpg?alt=media&token=cdf265b4-c76f-4620-a49d-3494d44db39b",
		title: "16th Birthday Party",
		key: "16th Birthday Party",
		venues: 0,
		category: "Birthday Parties",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2FFinal%20-%2021st%20Birthday.jpg?alt=media&token=209920e6-2110-4c54-ba6d-b4e7fb2294a6",
		title: "21st Birthday Party",
		key: "21st Birthday Party",
		venues: 0,
		category: "Birthday Parties",
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero2%2F50th%20Birthday.jpg?alt=media&token=49ad0f12-3da5-4143-a8bb-9430e1b4405c",
		title: "50th Birthday Party",
		key: "50th Birthday Party",
		venues: 0,
		category: "Birthday Parties",
	},
];

const ExploreEvents = ({ eventTypeName, setFilters }) => {
	const navigate = useNavigate();
	const [activeIndex, setActiveIndex] = useState(0);
	const [updatedEventsData, setUpdatedEventsData] = useState([]);

	// Fetch venue counts from backend
	const getEventCounts = async () => {
		try {
			const res = await axios.get(`${base_URL}/api/venues/get-count-by-event`);
			return res.data.count;
		} catch (err) {
			console.log(err);
			return null;
		}
	};

	const { data: eventCounts } = useQuery({
		queryKey: ["EventCounts"],
		queryFn: getEventCounts,
	});

	useEffect(() => {
		setUpdatedEventsData(
			baseEventsData1
				.map((item) => ({
					...item,
					venues:
						eventCounts && eventCounts[item.key] ? eventCounts[item.key] : 0,
				}))
				.filter((item) => item?.category === eventTypeName)
		);
	}, [eventCounts]);

	const CustomNextArrow = ({ onClick }) => (
		<div
			className="absolute sm:-right-10 sm:top-1/2 transform sm:-translate-y-1/2 cursor-pointer z-10"
			onClick={onClick}
		>
			<SlArrowRight className="text-[#FE4747] text-xl" />
		</div>
	);

	const CustomPrevArrow = ({ onClick }) => (
		<div
			className="absolute sm:-left-10 sm:top-1/2 transform sm:-translate-y-1/2 cursor-pointer z-10"
			onClick={onClick}
		>
			<SlArrowLeft className="text-[#FE4747] text-xl" />
		</div>
	);

	const settings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 4, // Adjust for how many items to show
		slidesToScroll: 1,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
		afterChange: (current) => setActiveIndex(current),
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
				},
			},
		],
	};

	// Base data with Firebase images
	const baseEventsData = [
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2FExhibition.png?alt=media&token=7d1bbffe-9231-40c1-bcf4-2de42b9fd63c",
			title: "Exhibitions",
			key: "Exhibitions",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fteam%20building.png?alt=media&token=58d44b7f-e5a5-4e04-9c25-d5c682e804cb",
			title: "Team Building",
			key: "Team Building",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fstaff%20party.png?alt=media&token=8c5e3fc6-c4ad-4e71-88a8-fd69733e690b",
			title: "Staff Party",
			key: "Staff Party",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2FPR%20events.png?alt=media&token=98104ad2-05bb-459b-b959-87f7cf48c2db",
			title: "PR events",
			key: "PR events",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fcorporate%20retreat.png?alt=media&token=e55a1059-f127-4c94-b429-85b5cae20352",
			title: "Corporate Retreat",
			key: "Corporate Retreat",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2FGala%20Dinner.png?alt=media&token=dd8b1c99-7f3f-456c-97d0-6c20d54018c9",
			title: "Corporate Gala dinner",
			key: "Corporate Gala dinner",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2FWedding%20Reception.png?alt=media&token=2226bf2f-4f97-4cd7-ac85-add2940178cc",
			title: "Wedding Reception",
			key: "Wedding Reception",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Foutdoor%20wedding.png?alt=media&token=5b19eb8e-94bf-4744-a77d-f0410bc3c724",
			title: "Outdoor Wedding",
			key: "Outdoor Wedding",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2FWedding%20Reception.png?alt=media&token=2226bf2f-4f97-4cd7-ac85-add2940178cc",
			title: "Wedding",
			key: "Wedding",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fengagement.png?alt=media&token=8635ca8d-c040-4c19-98c6-caa627fe4817",
			title: "Engagement",
			key: "Engagement",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fboard%20meeting.png?alt=media&token=475e6ef0-8e64-4c9c-8295-ca55613c34db",
			title: "Board Meetings",
			key: "Board Meetings",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fconfrenece.png?alt=media&token=21737274-e59b-4fdf-9e3d-417b29f47d77",
			title: "Conference",
			key: "Conference",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Ftranings.png?alt=media&token=ed85d698-3782-4ae7-aeef-66a1090839f6",
			title: "Training",
			key: "Training",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fnetworking.png?alt=media&token=e1ecf236-d12c-4aa1-b6b4-e9fdc4a55b0f",
			title: "Networking",
			key: "Networking",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2F16th%20Birthday.png?alt=media&token=c7fec128-ec72-4070-a1da-895bbc1bf8f7",
			title: "16th Birthday Party",
			key: "16th Birthday Party",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2F21st%20Birthday.png?alt=media&token=a99ca62a-8204-4b62-92ed-1eac93ffeccb",
			title: "21st Birthday Party",
			key: "21st Birthday Party",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2F50th%20Birthday.png?alt=media&token=66857d00-a918-44d2-b75a-bd70278db626",
			title: "50th Birthday Party",
			key: "50th Birthday Party",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2FKids%20Birthday%20Party.png?alt=media&token=acadb5b0-7f01-4539-8c64-ecf47a3a7b99",
			title: "Kids Party",
			key: "Kids Party",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fteen%20birthday.png?alt=media&token=ceee22d8-c5cd-481c-81e3-795f5e070c9b",
			title: "Teen Party",
			key: "Teen Party",
			venues: 0,
		},
		{
			img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmvhero3%2Fengagement.png?alt=media&token=8635ca8d-c040-4c19-98c6-caa627fe4817",
			title: "Proposals",
			key: "Proposals",
			venues: 0,
		},
	];

	// Update the data with counts from API

	// Calculate total count (optional - similar to ExploreCities)
	const totalEventCount = updatedEventsData.reduce(
		(acc, item) => acc + item.venues,
		0
	);
	if (totalEventCount) {
		localStorage.setItem("eventTotalCount", totalEventCount);
	}

	const handleClickCard = (item) => {
		const filterKey = filterKeys.find((key) => key.labelKey === item);
		if(filterKey) {
			setFilters({
				eventTypes: filterKey.valueKey,
			});
		}
		navigate(`/listing/1?filters=${JSON.stringify({ eventTypes: filterKey.valueKey })}`);
	};

	return (
		<div className="px-8 my-20">
			<h1 className="font-semibold md:text-[40px] text-[24px] text-[#222222] text-center mb-9">
				Explore Venues by {eventTypeName}
			</h1>
			<div className="md:w-[95%] w-[98%] mx-auto">
				{updatedEventsData && (
					<Slider {...settings}>
						{updatedEventsData.map((item, index) => (
							<div
								key={index}
								onClick={() => handleClickCard(item.key)}
								className="flex justify-center items-center mx-4 max-w-[90%] min-h-[500px] cursor-pointer"
							>
								<div className="w-full min-h-[500px] shadow-md rounded-lg flex justify-center items-center relative">
									<div className="w-full h-full">
										<img
											src={item.img}
											alt="bgImg"
											className="w-full h-full bg-cover rounded-lg"
										/>
									</div>
									<div className="w-full h-[100px] absolute bottom-0 rounded-lg left-0 flex justify-center items-center">
										<div className="">
											<h2 className="font-semibold text-2xl text-[#222222]">
												{item.title}
											</h2>
											<p className="text-[#5E5E5E] text-center mt-3 text-[16px] font-medium">
												{item.venues} Venues
											</p>
										</div>
									</div>
								</div>
							</div>
						))}
					</Slider>
				)}
			</div>
		</div>
	);
};

export default ExploreEvents;
